import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'
import ClearUserData from '../views/ClearUserData.vue'
import AboutView from '../views/AboutView.vue'
import TermsEn from '../views/UsageTermsEn.vue'
import TermsCn from '../views/UsageTermsZhCn.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/clearUserData',
    name: 'clearUserData',
    component: ClearUserData
  },
  {
    path: '/contacUs',
    name: 'contacUs',
    component: AboutView
  },
  {
    path: '/html',
    name: 'usageTermsEn',
    component: TermsEn
  },
  {
    path: '/terms',
    name: 'usageTermsEn',
    component: TermsEn
  },
  {
    path: '/terms-en',
    name: 'usageTermsEn',
    component: TermsEn
  },
  {
    path: '/terms-cn',
    name: 'usageTermsCn',
    component: TermsCn
  },
  {
    path: '/html/termsofservice_en.html',
    name: 'termsofservice_en',
    component: TermsEn
  },
  {
    path: '/html/termsofservice_zh.html',
    name: 'termsofservice_zh',
    component: TermsCn
  }
  // ,
  // {
  //   path: '*',
  //   redirect: '/'
  // }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach((to, from, next) => {
//   if (to.matched.length === 0) {
//     // 如果路由不匹配任何路由配置，重定向到默认页面或404页面
//     next('/'); // 假设你的默认页面是Home或NotFound组件
//   } else {
//     next(); // 确保一定要调用 next()
//   }
// });

export default router
